module.exports = __webpack_public_path__ + "img/tiktok-circle-light.909e509.svg";